document.addEventListener("DOMContentLoaded", () => {
  const quickActionButton = document.getElementById("quick-action");
  if (quickActionButton) {
    setTimeout(() => {
      quickActionButton.classList.add("active");
      const siteFooter = document.querySelector(".site-footer");
      if (siteFooter) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                quickActionButton.classList.remove("active");
              } else {
                quickActionButton.classList.add("active");
              }
            });
          },
          { threshold: 0.1 }
        );
        observer.observe(siteFooter);
      }
    }, 5000);
  }
});
